'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$OpenToCreate$() {
}
export { $c_Lpresto_crud$OpenToCreate$ as $c_Lpresto_crud$OpenToCreate$ };
$p = $c_Lpresto_crud$OpenToCreate$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$OpenToCreate$;
/** @constructor */
function $h_Lpresto_crud$OpenToCreate$() {
}
export { $h_Lpresto_crud$OpenToCreate$ as $h_Lpresto_crud$OpenToCreate$ };
$h_Lpresto_crud$OpenToCreate$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 415401953;
});
$p.l = (function() {
  return "OpenToCreate";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "OpenToCreate";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_crud$OpenToCreate$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$OpenToCreate$, "presto.crud$OpenToCreate$", ({
  VN: 1,
  ca: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_crud$OpenToCreate$ as $d_Lpresto_crud$OpenToCreate$ };
var $n_Lpresto_crud$OpenToCreate$;
function $m_Lpresto_crud$OpenToCreate$() {
  if ((!$n_Lpresto_crud$OpenToCreate$)) {
    $n_Lpresto_crud$OpenToCreate$ = new $c_Lpresto_crud$OpenToCreate$();
  }
  return $n_Lpresto_crud$OpenToCreate$;
}
export { $m_Lpresto_crud$OpenToCreate$ as $m_Lpresto_crud$OpenToCreate$ };
//# sourceMappingURL=presto.crud$-Open-To-Create$.js.map
